import PropTypes from 'prop-types';

/**
 * @type React.FC<PropTypes.InferType<Wrapper.propTypes>>
 * @deprecated
 */
const Wrapper = ({
  children,
}) => {
  return (
    children
  );
};

Wrapper.propTypes = {
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  aligncontent: PropTypes.string,
  justify: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
    .isRequired,
};

export default Wrapper;
